module.exports = __webpack_public_path__ + "img/MW_Telegram_Instruction_3.0acbb16d.gif";